module.exports = __webpack_public_path__ + "resource/img/photo.5b8f348f.svg";